// @ts-nocheck
import { FILTER_PARAMS } from './constants';
import qs from 'qs';
import axios from 'axios';
import getDescendantProp from './methods/getDescendantProp';
import moment from 'moment';

export const catchAsync =
    (fn, onError) =>
    (...args) =>
        fn(...args).catch(error => {
            let foundErrors;
            if (error.response) {
                foundErrors = error.response.data?.info?.errors;

                if (foundErrors) {
                    console.error(foundErrors);
                }
            } else {
                foundErrors = [error];
                console.error(error);
            }

            if (onError) onError(foundErrors);

            return { info: { success: false, errors: foundErrors } };
        });

export const generateRequestParams = params => {
    return Object.entries(params)
        .reduce((result, [key, value]) => {
            if (
                typeof value === 'undefined' ||
                value === null ||
                (typeof value === 'string' && value.length === 0) ||
                (Array.isArray(value) && value.length === 0)
            )
                return result;

            return result + `&${key}=${value}`;
        }, '')
        .slice(1);
};

export const generateUpdatedData = (currentData, newData) => {
    const updatedData = {};

    Object.keys(newData).forEach(key => {
        if (newData[key] !== currentData[key]) {
            updatedData[key] = newData[key];
        }
    });

    return Object.keys(updatedData).length ? updatedData : null;
};

export const generateParams = values => {
    const newValues = Object.fromEntries(
        Object.entries(values)
            .filter(([key, value]) => value !== undefined && value !== null)
            .filter(([key, value]) => typeof value !== 'string' || value.trim() !== '')
    );

    const objectKeys = Object.keys(newValues);

    if (objectKeys.includes(FILTER_PARAMS.range)) {
        const [startDate, endDate] = newValues.range;

        newValues.startDate = startDate.valueOf();
        newValues.endDate = endDate.valueOf();

        delete newValues.range;
    }

    if (objectKeys.includes(FILTER_PARAMS.dailyStartTime)) {
        newValues[FILTER_PARAMS.dailyStartTime] = values[FILTER_PARAMS.dailyStartTime].valueOf();
    }

    if (objectKeys.includes(FILTER_PARAMS.dailyEndTime)) {
        newValues[FILTER_PARAMS.dailyEndTime] = values[FILTER_PARAMS.dailyEndTime].valueOf();
    }

    if (objectKeys.includes(FILTER_PARAMS.amountType)) {
        newValues.startAmountRangeType = newValues[FILTER_PARAMS.amountType];
        newValues.endAmountRangeType = newValues[FILTER_PARAMS.amountType];

        delete newValues[FILTER_PARAMS.amountType];
    }

    if (objectKeys.includes('firstLevel')) {
        newValues.groupBy = newValues[FILTER_PARAMS.mainGroupBy];
    }

    if (objectKeys.includes('secondLevel')) {
        newValues.groupBy = newValues[FILTER_PARAMS.secondaryGroupBy];
    }

    if (objectKeys.includes('firstLevel') || objectKeys.includes('secondLevel') || objectKeys.includes('thirdLevel')) {
        delete newValues[FILTER_PARAMS.mainGroupBy];
        delete newValues[FILTER_PARAMS.secondaryGroupBy];
        delete newValues.firstLevel;
        delete newValues.secondLevel;
        delete newValues.thirdLevel;
    }

    return newValues;
};

export const cancelTokens = {};

export const getNewCancelToken = tokenKey => {
    const cancelToken = axios.CancelToken.source();
    cancelTokens[tokenKey] = cancelToken;
    return cancelToken.token;
};

export const cancelRequest = tokenKey => {
    if (cancelTokens[tokenKey]) {
        cancelTokens[tokenKey].cancel({
            cancelled: true,
            message: 'Operation cancelled manually.',
        });
        delete cancelTokens[tokenKey];
    }
};

export const paramsSerializer = params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
};

export const generatePlayerSearchParams = (values, operationInputFieldNames, dateFieldNames) => {
    const params = { ...values };

    for (const key in params) {
        if (operationInputFieldNames.includes(key)) {
            const operationTypeKey = getDescendantProp(FILTER_PARAMS.playerSearch, key).type;
            const amountKey = getDescendantProp(FILTER_PARAMS.playerSearch, key).amount;
            const digitIndex = params[key].split('').findIndex(character => /[0-9]/g.test(character));

            params[operationTypeKey] = params[key].slice(0, digitIndex);
            params[amountKey] = params[key].slice(digitIndex);
            delete params[key];
        } else if (dateFieldNames.includes(key)) {
            if (params[key]?.length === 2) {
                const [start, end] = params[key];

                const paramNames = getDescendantProp(FILTER_PARAMS.playerSearch, key);

                params[paramNames.start] = moment(start).valueOf();
                params[paramNames.end] = moment(end).valueOf();
                delete params[key];
            } else {
                params[key] = moment(params[key]).valueOf();
            }
        }
    }

    return params;
};
